import React from "react";
import { connect } from "react-redux";
import { Creators } from "@ReduxStore/actionTypes";
import { selectors } from "@ReduxStore/reducers";
import { Icon, Modal, FlyoutFullScreen } from "@accessdev/arc-ui-react";
import Media from "react-media";
import { mediaBreakpoints } from "@accessdev/arc-ui-react/utils/js";
import { DealsContext, FLYOUT_SCREENS } from "@Src/routes/deals/Deals.context";
import ScreensIndex from "./ScreensIndex";
import Store404 from "@Src/routes/store/Store404";
import ReportAProblem from "./ReportAProblem";
import { t } from "@lingui/core/macro";

import "./OfferModal.scss";

const { fetchStoreLocation, resetStoreLocation } = Creators;

const { getStoreLocation, getMember, getOfferFilter, getStoreError } = selectors;
class OfferModalComponent extends React.Component {
  static contextType = DealsContext;
  constructor(props) {
    super(props);
    this.state = {
      isFlyoutOpen: true,
      gettingStoreInfo: false,
    };
  }

  componentDidMount() {
    // If offerRedirect prop is true then the offerKey endpoint has already been called, and there is no reason to call the store endpoint
    if (!this.props.offerRedirect) {
      this.getStoreInfo();
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.storeInfo !== this.props.storeInfo) {
      this.setState({ gettingStoreInfo: false });
    }
    if (prevProps.member.uid !== this.props.member.uid) {
      // reset old store and get the new one with updated data
      this.props.resetStoreLocation();
      this.getStoreInfo();
    }
  }

  componentWillUnmount() {
    const isOnStorePage = this.props.routerLocation?.pathname.includes("/store/");
    if (!isOnStorePage) {
      this.props.resetStoreLocation();
    }
  }

  getStoreInfo = () => {
    this.setState({ gettingStoreInfo: true });
    const currentLocation = this.props.offerFilter.currentLocation;
    const location = currentLocation;
    this.props.fetchStoreLocation({
      selectedLocationKey: this.props.fromMap ? this.context.store.location_key : null,
      storeKey: this.props.store_key,
      currentLocation: this.props.fromMap ? this.context.store.geo_location : location,
    });
  };

  handleGoBack = () => {
    if (this.context.redeemedLimitedOffer) {
      this.getStoreInfo();
      this.context.setRedeemedLimitedOffer(false);
    }
    this.context.handleGoBack(this.props.closeModal);
  };

  renderScreen = () => {
    if (this.props.storeError) return <Store404 fromModal={true} />;

    return <ScreensIndex />;
  };

  isShowingCoupon = () => {
    if (this.context.currentFlyoutScreen.includes(t`SHOW SCREEN`)) return true;

    return false;
  };

  shouldShowReportAProblem = () => {
    const { selectedLocation, currentFlyoutScreen } = this.context;
    const { member } = this.props;

    const isShowingCoupon =
      currentFlyoutScreen === FLYOUT_SCREENS.SHOW_COUPON ||
      currentFlyoutScreen === FLYOUT_SCREENS.SHOW_PRINT_PREVIEW;

    const noUserLoggedIn = !member.uid;

    if (isShowingCoupon || noUserLoggedIn || !selectedLocation) {
      return false;
    }

    return true;
  };

  render() {
    const isChatEnabled = process.env.REACT_APP_CHAT_ENABLED === "true";
    const { closeModal, storeInfo } = this.props;

    if (storeInfo === null || this.state.gettingStoreInfo) return null;

    return (
      <>
        <Media query={mediaBreakpoints.forTabletUp}>
          <Modal
            onClose={this.handleGoBack}
            defaultPadding={false}
            className={`offer-details-modal ${this.isShowingCoupon() ? "coupon" : ""}`}
            focusOnOpen=".offer-detail__focus-target"
            radius="md"
          >
            {this.renderScreen()}
            {this.shouldShowReportAProblem() && <ReportAProblem />}
          </Modal>
        </Media>
        <Media query={mediaBreakpoints.forPhoneOnly}>
          <FlyoutFullScreen
            focusOnOpen=".offer-detail__focus-target"
            defaultPadding={false}
            isOpen={this.state.isFlyoutOpen}
            onClose={closeModal}
            variant={`offer-details-flyout ${
              !this.isShowingCoupon() && isChatEnabled ? "offer-details__withchat" : ""
            }`}
          >
            <div className={`offer-details__wrapper`}>
              <div className="offer-details-flyout__nav-bar">
                <Icon
                  type="button"
                  icon="close"
                  onClick={this.handleGoBack}
                  className="offer-details-flyout__close-icon"
                />
              </div>
              {this.renderScreen()}
              {this.shouldShowReportAProblem() && <ReportAProblem />}
            </div>
          </FlyoutFullScreen>
        </Media>
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  storeInfo: getStoreLocation(state),
  member: getMember(state),
  offerFilter: getOfferFilter(state),
  storeError: getStoreError(state),
});

export default connect(mapStateToProps, {
  fetchStoreLocation,
  resetStoreLocation,
})(OfferModalComponent);
